export default {
  isLogined() {
    var token = window.localStorage.getItem('ei_token');
    return token ? true : false;
  }
}



// WEBPACK FOOTER //
// ./src/js/account.js